import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  surveyOpt: 'none', // none yes self
  serviceOpt: 'none', // basic standard premium
  progressOpt: 'Service',
  install: 'no',
  survey: [
    { type: 'pending', selected: false, complete: false },
    { type: 'quick', selected: false, complete: false },
    { type: 'diy', selected: false, complete: false },
    { type: 'paid', selected: false, complete: false },
  ],
  booking: [
    { type: 'survey', surveyDate: '', valid: false },
    { type: 'fit', fitDate: '', valid: false },
  ],
  surveyQuick: [
    { section: 'parking', answer: '', details: '', complete: false },
    { section: 'access', answer: '', details: '', complete: false },
    { section: 'wall', answer: '', details: '', complete: false },
    { section: 'onsite', answer: '', details: '', complete: false },
    { section: 'placement', answer: '', details: '', complete: false },
    { section: 'obstructions', answer: '', details: '', complete: false },
    { section: 'fitspace', answer: '', details: '', complete: false },
  ],
  largeQty: 0,
  XLQty: 0,
  XXLQty: 0,
  mirrorTotal: 0,
  bespokeMirrorTotal: 0,
  fittingsTotal: 0,
  bespokeMirrors: [],
  isValid: true,
  isBackValid: false,
  isNextValid: false,
  isCheckoutValid: false,
  optimoDates: {},
  fittings: [
    { type: 'Jclips', qty: 0, price: 6 },
    { type: 'discClips', qty: 0, price: 8.0 },
    { type: 'Jchannel', qty: 0, price: 35 },
    { type: 'adhesive', qty: 0, price: 7.5 },
  ],
  checkoutLoading: false,
};

const gymCompSlice = createSlice({
  name: 'gymComp',
  initialState,
  reducers: {
    // resetStateValue: (state, action) => {
    //   const { key, defaultValue } = action.payload;
    //   const keys = key.split('.');
    //   let nestedState = state;
    //   keys.slice(0, -1).forEach((k) => {
    //     nestedState = nestedState[k];
    //   });
    //   nestedState[keys[keys.length - 1]] = defaultValue;
    // },
    resetStateValue: (state, action) => {
      const { key, defaultValue } = action.payload;
      const keys = key.split('.');
      let nestedState = state;

      // Ensure each level of the path exists or is created
      keys.slice(0, -1).forEach((k) => {
        if (!nestedState[k]) {
          nestedState[k] = {}; // Create an object if it doesn't exist
        }
        nestedState = nestedState[k];
      });

      // Set the value for the last key to the default value
      nestedState[keys[keys.length - 1]] = defaultValue;
    },
    resetSurveyState: (state) => {
      state.largeQty = 0;
      state.XLQty = 0;
      state.XXLQty = 0;
      state.mirrorTotal = 0;
      state.bespokeMirrorTotal = 0;
      state.fittingsTotal = 0;
      state.install = 'no';
      state.progressOpt = 'Survey';
      state.isBackValid = false;
      state.bespokeMirrors = [];
      state.progressOpt = 'survey';
      state.fittings = state.fittings.map((fitting) => ({
        ...fitting,
        qty: 0,
      }));
      state.survey = state.survey.map((item) => ({
        ...item,
        selected: item.type === 'paid' ? true : false,
        complete: item.type === 'paid' ? true : false,
      }));
    },
    increment: (state, action) => {
      const { size } = action.payload; // size will be either 'small', 'large', 'XL', or 'XXL'
      state[`${size}Qty`] += 1; // Dynamically update the respective quantity
      state.mirrorTotal += 1;
    },
    decrement: (state, action) => {
      const { size } = action.payload; // size will be either 'small', 'large', 'XL', or 'XXL'
      if (state[`${size}Qty`] > 0) {
        state[`${size}Qty`] -= 1; // Dynamically decrement, but ensure it stays above 1
        state.mirrorTotal -= 1;
      }
    },
    // For fittings, increment the quantity
    incrementFit: (state, action) => {
      const fitting = state.fittings.find(
        (fit) => fit.type === action.payload.fittingType
      ); // Find the fitting by type
      if (fitting) {
        fitting.qty += 1;
        state.fittingsTotal += 1;
      }
    },
    // For fittings, decrement the quantity
    decrementFit: (state, action) => {
      const fitting = state.fittings.find(
        (fit) => fit.type === action.payload.fittingType
      ); // Find the fitting by type
      if (fitting && fitting.qty > 0) {
        fitting.qty -= 1;
        state.fittingsTotal -= 1;
      }
    },
    addBespokeMirror: (state, action) => {
      state.bespokeMirrors.push(action.payload); // Add a new mirror object to the array
    },
    updateBookingValid: (state, action) => {
      const { type, valid } = action.payload;
      state.booking = state.booking.map((item) =>
        item.type === type ? { ...item, valid } : item
      );
    },
    setStateValue: (state, action) => {
      const { key, value } = action.payload;

      // Check if the key is nested or not
      if (key.includes('.')) {
        const keys = key.split('.');
        let nestedState = state;

        // Ensure all levels of nesting exist
        keys.slice(0, -1).forEach((k, i) => {
          if (!nestedState[k]) {
            const nextKey = keys[i + 1];
            nestedState[k] = isNaN(nextKey) ? {} : [];
          }
          nestedState = nestedState[k];
        });

        // Set the value in the deepest part of the nested object/array
        nestedState[keys[keys.length - 1]] = value;
      } else {
        // Directly set the value for non-nested keys
        state[key] = value;
      }
    },
    updateSurveyAnswer: (state, action) => {
      const { section, answer, details, complete } = action.payload;
      const item = state.surveyQuick.find((q) => q.section === section);
      if (item) {
        item.answer = answer;
        item.details = details;
        item.complete = complete;
      }
    },
    addWallDimensions: (state) => {
      const newWallNumber =
        state.surveyQuick.filter((q) => q.section === 'walldims').length + 1;
      state.surveyQuick.push({
        section: 'walldims',
        wallNumber: String(newWallNumber),
        width: '',
        height: '',
      });
    },
  },
});

export const {
  setStateValue,
  resetStateValue,
  resetSurveyState,
  increment,
  decrement,
  incrementFit,
  decrementFit,
  addBespokeMirror,
  updateBookingValid,
  updateSurveyAnswer,
  addWallDimensions,
} = gymCompSlice.actions;

export default gymCompSlice.reducer;
